import styled from "@emotion/styled";

import { DesignToken, SpacingToken } from "@livechat/design-system-react-components";

import { Icon } from "components/icon";
import { withVar } from "themes/helpers";

export const StyledAccessWarning = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 5px 10px;
  border-bottom: 1px solid
    ${
      // FIXME: Fix this the next time the file is edited.
      // eslint-disable-next-line @typescript-eslint/explicit-function-return-type, @typescript-eslint/no-explicit-any
      (props: any) => props.theme.borderColor
    };
  color: ${
    // FIXME: Fix this the next time the file is edited.
    // eslint-disable-next-line @typescript-eslint/explicit-function-return-type, @typescript-eslint/no-explicit-any
    (props: any) => props.theme.primaryColor80
  };
  text-align: center;
  background: ${withVar(DesignToken.SurfaceSecondaryDefault)};
  font-size: 13px;
  line-height: 1.4;
`;

export const StyledAccessWarningIcon = styled(Icon)`
  margin-right: 6px;
`;

export const MessageElementWrapper = styled.div`
  margin-block: ${withVar(SpacingToken.Spacing2)};
  margin-inline: 0;
`;
